/**
 * Content Schema Constants
 *
 * Single source of truth for Content Schema related constants.
 * Used across frontend to ensure consistency.
 */

/**
 * Content type identifier for Content Schema format
 *
 * This value is sent to backend to indicate that content is in Content Schema format.
 * Backend uses this to trigger entity extraction and node validation.
 */
export const CONTENT_TYPE_CONTENT_SCHEMA = "Content Schema" as const;

/**
 * Content type identifier for Markdown format
 *
 * @deprecated Kept for backward compatibility with legacy data.
 * All new content should use CONTENT_TYPE_CONTENT_SCHEMA.
 */
export const CONTENT_TYPE_MARKDOWN = "markdown" as const;

/**
 * Content type union type
 */
export type ContentType = typeof CONTENT_TYPE_CONTENT_SCHEMA | typeof CONTENT_TYPE_MARKDOWN;
